//引入外部模組
import 'jquery.qrcode';
import {BodyCtrl} from '@/body_ctrl';




//引入外部模組
let bodyCtrl = new BodyCtrl;




//QR Code
class QRcode {
  constructor() {
    //主體
    this.web       = $('#qrcodeWeb .qrcode>i');
    this.nav       = $('#rwdNav');
    this.navLB     = $('#rwdLightbox');
    this.qrCodeBtn = this.nav.find('.qrcodeWeb');

    //業務個人
    this.personalId = $('#personalIdVal').val();
    this.personal   = $('#qrcodePersonal .qrcode>i');

    //物件內頁
    this.url    = location.href;
    this.realty = $('#qrcodeRealty .qrcode>i');
  }
  //主體
  webQRcode() {
    this.web.qrcode({
      render: 'table',
      width : 240,
      height: 240,
      text  : 'http://www.singfujia.com'
    });

    this.qrCodeBtn.on('click', () => {
      this.nav.removeClass('active');
      this.navLB.removeClass('active');
      bodyCtrl.ctrl('scrollShow');  //控制瀏覽器捲軸
      bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
    });
  }
  //物件內頁
  realtyQRcode() {
    
    this.realty.qrcode({
      render: 'table',
      width : 240,
      height: 240,
      text  : this.url.toString()
    });
  }
  //業務個人
  personalQRcode() {
    this.personal.qrcode({
      render: 'table',
      width : 240,
      height: 240,
      text  : 'http://www.singfujia.com/?personal_id=' + this.personalId
    });
  }
}




//輸出
export {QRcode};


// WEBPACK FOOTER //
// ./js_new/qrcode.js